import { FC } from 'react';
import { useTheme } from 'styled-components';

import { Typography } from '../../../designComponents';
import { DetailsStyled } from './style';
type DetailsPropsTypes = {
  id: number;
  label: string;
  desc: string;
};
const Details: FC<DetailsPropsTypes> = ({ desc, id, label }) => {
  const theme = useTheme();
  return (
    <DetailsStyled>
      <div>
        <Typography
          style={{
            backgroundColor: theme.colors.skyGreenLight,
            borderRadius: '30px',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme.colors.white,
          }}
        >
          {id || 1}
        </Typography>
      </div>
      <div className="main-text">
        <Typography
          style={{ color: theme.colors.landingSecondaryText }}
          variant="title"
        >
          {label || 'Upload Building Drawings'}
        </Typography>
        <Typography>
          {desc ||
            " Clients begin by uploading their building drawings to our platform. Whether it's an AutoCAD file or a PDF, our system accepts a variety of formats for convenience."}
        </Typography>
      </div>
    </DetailsStyled>
  );
};

export default Details;
